const EBOKS_PROD_DOMAIN = 'e-boks.dk';
const EBOKS_TEST_DOMAIN = 'e-boks.cloud';

export const getCookieRootDomain = (): string => {
    if (globalThis.location.hostname.includes(EBOKS_PROD_DOMAIN)) {
        return EBOKS_PROD_DOMAIN;
    }

    if (globalThis.location.hostname.includes(EBOKS_TEST_DOMAIN)) {
        return EBOKS_TEST_DOMAIN;
    }

    return globalThis.location.hostname;
};

export const getHostname = (): string => globalThis?.location?.hostname;

export const getSearchParameter = (key: string): string => {
    const urlSearchParameters = new URLSearchParams(globalThis?.location?.search);

    return urlSearchParameters.has(key) ? urlSearchParameters.get(key) : '';
};

export const isIOS = (): boolean => {
    const window = globalThis as unknown as Window & { MSStream: boolean };

    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

export const isTouchScreen = (): boolean => 'ontouchstart' in document.documentElement;
